import bounceApiClient from 'legacy/common/utils/bounceApiClient';
import { OutgoingCheckoutSessionDto } from 'api/dtos/events/checkout';
import {
  UpdateCheckoutSessionParams,
  UpdateUnauthenticatedCheckoutSessionParams,
  ConfirmCheckoutSessionParams
} from 'api/types/events/checkout';

/**
 * Starts a checkout session for an event
 */
export async function startCheckoutSession(
  eventId: string
): Promise<OutgoingCheckoutSessionDto> {
  const { data } = await bounceApiClient.post(
    `/api/events/${eventId}/checkout/v3`
  );

  return data;
}

/**
 * Starts an unauthenticated checkout session
 */
export async function startUnauthenticatedCheckoutSession(
  eventId: string
): Promise<OutgoingCheckoutSessionDto> {
  const { data } = await bounceApiClient.post(
    `/checkoutSessions/v3/${eventId}`
  );

  return data;
}

/**
 * Updates a checkout session for an authenticated user
 */
export async function updateCheckoutSession({
  eventId,
  paymentIntentId,
  body
}: UpdateCheckoutSessionParams): Promise<OutgoingCheckoutSessionDto> {
  const { data } = await bounceApiClient.put(
    `/api/events/${eventId}/checkout/v3/${paymentIntentId}`,
    body
  );

  return data;
}

/**
 * Updates a checkout session for an unauthenticated user
 */
export async function updateUnauthenticatedCheckoutSession({
  eventId,
  paymentIntentId,
  body
}: UpdateUnauthenticatedCheckoutSessionParams): Promise<OutgoingCheckoutSessionDto> {
  const { data } = await bounceApiClient.put(
    `/checkoutSessions/v3/${eventId}/${paymentIntentId}`,
    body
  );

  return data;
}

/**
 * Confirms a checkout session
 */
export async function confirmCheckoutSession({
  eventId,
  paymentIntentId,
  body
}: ConfirmCheckoutSessionParams): Promise<{ redirectUrl?: string }> {
  const { data } = await bounceApiClient.post(
    `/api/events/${eventId}/checkout/v3/${paymentIntentId}/confirm`,
    body
  );

  return data;
}
